import { useSelector } from "react-redux";
import * as FaIcons from "react-icons/fa"; // FontAwesome icons
import { TbBrandReactNative } from "react-icons/tb"; // Tabler icon for React Native
import React, { useState } from "react";

function SkillItem({ name, iconName, svg }) {
  const [imageError, setImageError] = useState(false);

  let IconComponent = null;
  if (iconName) {
    if (FaIcons[iconName]) {
      IconComponent = FaIcons[iconName];
    } else if (iconName === "TbBrandReactNative") {
      IconComponent = TbBrandReactNative;
    }
  }

  // Support image/svg paths provided via 'svg' OR 'iconName' (e.g. "/assets/react-native.svg")
  const imageSrc =
    typeof svg === "string" && svg
      ? svg
      : typeof iconName === "string" && (iconName.startsWith("/") || iconName.includes("."))
      ? iconName
      : null;

  const isReactNative = name && name.toLowerCase().includes("react native");

  return (
    <div className="skill-item flex items-center space-x-3 p-3 rounded-lg shadow-md bg-gray-100 dark:bg-gray-800">
      {IconComponent ? (
        <IconComponent size={40} className="text-blue-500 flex-shrink-0" />
      ) : imageSrc && !imageError ? (
        <img
          src={imageSrc}
          alt={name}
          className="w-10 h-10 object-contain flex-shrink-0"
          onError={() => setImageError(true)}
        />
      ) : svg && typeof svg !== "string" ? (
        React.createElement(svg, { className: "w-10 h-10 flex-shrink-0" })
      ) : isReactNative ? (
        <TbBrandReactNative size={40} className="text-blue-500 flex-shrink-0" />
      ) : (
        <span className="text-xl flex-shrink-0">🛠</span>
      )}
      <span className="text-gray-900 dark:text-gray-200 font-medium truncate max-w-[100px]">{name}</span>
    </div>
  );
}

export default function Skills() {
  const { loading, error, data } = useSelector((state) => state.portfolio);

  if (loading) return <div>Loading skills...</div>;
  if (error) return <div>Error loading skills</div>;
  if (!data?.skills || !Array.isArray(data.skills) || data.skills.length === 0) {
    return <div>No skills available</div>;
  }

  return (
    <section id="skills" className="py-20 bg-gray-50 dark:bg-gray-800">
      <div className="container mx-auto px-6 mb-10">
        <h2 className="text-3xl font-heading font-bold mb-10 text-center">Skills</h2>
        <div className="skills-container grid grid-cols-2 md:grid-cols-4 gap-6">
          {data.skills.map((skill, idx) => (
            <SkillItem key={idx} {...skill} />
          ))}
        </div>
      </div>
    </section>
  );
}
